import React from 'react';
import dayjs from 'dayjs';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useDispatch } from 'react-redux';
import Badge from './Badge';
import { CommonActions } from '../../../Reducer/CommonReducer';

export default function ListItem({ item, showBorder = true }) {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();

  return (
    <button
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 16px',
        backgroundColor: 'transparent',
        width: '100%',
        border: 'none',
        borderBottom: showBorder ? '1px solid #E0E0E0' : 'none',
        textAlign: 'left',
      }}
      onClick={() => {
        dispatch(CommonActions.increaseStep());

        const prefix = item.prefix || 'C';
        navigate(`/M_Meeting/detail/${prefix}${item.chaebun}`);
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '4px',
        }}
      >
        <Badge data={item} />

        <p style={{ fontWeight: 'bold', fontSize: '14px' }}>
          {item.proceedingsTitle}
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          paddingTop: 8,
          gap: 8,
          fontSize: '14px',
          color: '#9c9a9aff',
        }}
      >
        <p style={{ whiteSpace: 'nowrap' }}>
          {item.name} | {dayjs(item.updateDate).format('YYYY-MM-DD')}
        </p>
      </div>
    </button>
  );
}
